<template>
    <div>
    <div v-if="!showShareRange">
        <zm-row v-if="!isHashComponent && !versionListVisible">
            <zm-button plain @click="showCreate()" type="primary" v-if="permission.manageableResources.length">Create</zm-button>
            <zm-button plain @click="downloadTemplate('csv')" type="primary">Download CSV Template</zm-button>
            <!-- <zm-dropdown split-button type="primary" @click="showCreate" @command="downloadTemplate" class="create-dropdown">
                Create
                <zm-dropdown-menu slot="dropdown">
                    <zm-dropdown-item command="upload">
                            Batch Create
                    </zm-dropdown-item>
                    <zm-dropdown-item command="csv">Download CSV Template</zm-dropdown-item>
                    <zm-dropdown-item command="xlsx">Download XLSX Template</zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown> -->
            <zm-upload
                class="upload-demo"
                v-if="permission.manageableResources.length"
                :action="getUserAction()"
                id="secret-upload"
                :headers="headers"
                :on-success="onSuccess"
                :on-error="onError"
                :data="uploadData"
                :show-file-list="false"
                :http-request="myUpload"
                :file-list="fileList">
                <zm-button plain class="btn-right" type="primary" v-loading.fullscreen.lock="uploading">Import</zm-button>
            </zm-upload>
            <zm-button plain @click="showSearchHash()" type="primary" v-if="!saferDisplay && permission.manageableResources.length">Search By Value</zm-button>
            <zm-button plain @click="showDuplicate()" type="primary" v-if="permission.manageableResources.length">Duplicate</zm-button>
            <zm-button :plain="!downloadMetadataLoading" @click="downloadMetadata()" type="primary" :loading="downloadMetadataLoading">Download Metadata</zm-button>
            <zm-dropdown trigger="click" @command="downloadUpdateTemplate" class="create-dropdown">
                <zm-button type="primary" plain>Download Update Template</zm-button>
                <zm-dropdown-menu slot="dropdown">
                    <zm-dropdown-item v-for="item in actionList" :key="item" :command="item">{{ item }}</zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown>
            <zm-upload
                v-show="false"
                :action="getUploadForBatchUpdateAction()"
                id="update-upload"
                ref="batchUpload"
                :file-list="updateTemplate.fileList"
                :headers="headers"
                :on-success="batchUploadSuccess"
                :on-error="batchUploadError"
                :data="updateTemplate"
                >
            </zm-upload>
            <zm-dropdown trigger="click" @command="showUpdateTemplate" class="create-dropdown">
                <zm-button type="primary" plain>Batch Update</zm-button>
                <zm-dropdown-menu slot="dropdown">
                    <zm-dropdown-item v-for="item in actionList" :key="item" :command="item">{{ item }}</zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown>
            <!-- <zm-button plain @click="showUpdateTemplate()" type="primary" v-if="permission.manageableResources.length">Batch Update</zm-button> -->
        </zm-row>
        <zm-row v-if="versionListVisible">
            <zm-button type="text" icon="zm-icon-left" @click="hideVersionList">{{ versionSecret.alias}} </zm-button>
        </zm-row>
        <version-list v-if="versionListVisible" :secret="versionSecret" :permission="permission"></version-list>
        <div v-loading="loading" v-else>
        <zm-row v-if="!isHashComponent">
            <zm-button v-if="filter.searchBy === 'refer'" type="icon" icon="zm-icon-left" @click="backToSearch" class="btn-in-line"></zm-button>
            <zm-select v-model="namespace" class="select-inline" placeholder="namespace" filterable clearable @change="setNamespace" popper-class="select-popper">
                <zm-option v-for="item in namespaceList" :key="item" :value="item"></zm-option>
            </zm-select>
            <zm-select v-model="filter.applicationId" placeholder="Application" filterable clearable @change="handelAppChange(true)"
                class="select-inline" popper-class="select-popper" :width-limit="{ disableTip: true }">
                <zm-option v-for="item in applicationList" :key="item.id" :label="item.applicationName" :value="item.id"></zm-option>
            </zm-select>
            <zm-select v-for="(item, index) in filter.prefixPath" :key="index" v-model="filter.prefixPath[index]" filterable allow-create clearable
                @change="handlePrefixChange(index, 'filter', true)" class="select-inline">
                <zm-option v-for="item in pathList.filter[index]" :key="item.id" :label="item.path" :value="item.path"></zm-option>
            </zm-select>
            <span>Alias: </span>
            <zm-input v-model="filter.alias" placeholder="alias" style="width: 120px"
            @keyup.enter.native="fetchData"></zm-input>
            <span style="margin-left: 10px;" v-if="filter.searchBy !== 'refer' && !saferDisplay">Hash: </span>
            <zm-input v-model="filter.secretHashValue" placeholder="hash" style="width: 120px"
            @keyup.enter.native="fetchData" v-if="filter.searchBy !== 'refer' && !saferDisplay"></zm-input>
            <span style="margin-left: 10px;">Strict Mode
                <zm-tooltip class="item" content="Search secrets only in current path without trasversing subpath."
                placement="bottom" popper-class="strictmode-popper">
                    <span><i class="zm-icon-help-outline zm-input__icon" style="line-height: 10px;"></i></span>
                </zm-tooltip>
            : </span>
            <zm-switch v-model="filter.strict" @change="fetchData"></zm-switch>
            <zm-button type="icon" icon="zm-icon-search" @click="fetchData" class="btn-in-line" :loading="loading"></zm-button>
            <zm-button type="icon" title="verify secret version" icon="zm-icon-version" @click="verifySecretVersion" class="btn-in-line" :loading="loadingVerify"></zm-button>
            <zm-button type="icon" title="show secret share range" icon="zm-icon-share" @click="showShareRange = true" class="btn-in-line"></zm-button>
        </zm-row>
        <!-- <zm-row v-if="!isHashComponent && filter.searchBy === 'refer'">
            <zm-button type="icon" icon="zm-icon-search" @click="fetchData" class="btn-in-line" :loading="loading"></zm-button>
        </zm-row> -->
        <div class="table-container">
            <zm-table ref="multipleTable" :data="list.length ? list : [{}]" @selection-change="handleSelect" style="margin-top: 5px" :init-displayed-column="initDisplayedColumn">
                <zm-table-column type="selection" width="55" :selectable="selectPermission" v-if="list.length"></zm-table-column>
                <zm-table-column type="index" width="50px" v-if="list.length"></zm-table-column>
                <zm-table-column prop="alias" label="Alias" show-overflow-tooltip></zm-table-column>
                <!-- <zm-table-column prop="group" label="Group" width="110px" show-overflow-tooltip></zm-table-column> -->
                <zm-table-column prop="keyType" label="Key Type" width="120px"></zm-table-column>
                <zm-table-column prop="shareType" label="Share Type" width="120px"></zm-table-column>
                <zm-table-column prop="referenceSecretName" label="Referenced Secret" show-overflow-tooltip></zm-table-column>
                <zm-table-column prop="fullPath" label="Full Path" show-overflow-tooltip></zm-table-column>
                <zm-table-column prop="hash" label="Secret" show-overflow-tooltip v-if="!saferDisplay">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        Secret<zm-button size="small" class="btn-contain" type="icon" title="show secrets" :loading="showSecretsLoading"
                        :icon="showSecretsVisible ? 'zm-icon-eyes-close' : 'zm-icon-eyes'" @click="showSecrets()"></zm-button>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.showHash ? scope.row.secretHashValue : scope.row.secret }}
                    </template>
                </zm-table-column>
                <zm-table-column prop="isEnable" label="Enable" width="100px">
                    <template slot-scope="scope">
                        <i :class="scope.row.isEnable ? 'zm-icon-ok' : 'zm-icon-close'" v-if="list.length"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="isSensitive" label="Sensitive" width="140px">
                    <template slot-scope="scope">
                        <i :class="scope.row.isSensitive ? 'zm-icon-ok' : 'zm-icon-close'" v-if="list.length"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="isInRevoke" label="In Revoke" width="150px">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <zm-dropdown trigger="click" @command="filterRevoke">
                            <span class="zm-dropdown-link">
                                In Revoke<i class="zm-icon-down zm-icon--right"></i>
                            </span>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item :command="null">All</zm-dropdown-item>
                                <zm-dropdown-item :command="true">True</zm-dropdown-item>
                                <zm-dropdown-item :command="false">False</zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown>
                    </template>
                    <template slot-scope="scope">
                        <i :class="scope.row.isInRevoke ? 'zm-icon-ok' : 'zm-icon-close'" v-if="list.length"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="versionInfos" label="Version Infos" width="180px">
                    <template slot-scope="scope">
                        <!-- <zm-tooltip v-for="item in scope.row.versionInfos" :key="item.versionId"
                            :append-to-body="false"
                            class="item" :content="item.versionId" placement="top-start"
                            > -->
                        <div v-for="item in scope.row.versionInfos" :key="item.versionId">
                            <zm-tag v-if="item.versionStage.toLowerCase().indexOf('current') > -1" type="success" size="mini">
                                {{ item.versionStage }}: {{ item.versionId.slice(item.versionId.length - 6, item.versionId.length) }}</zm-tag>
                            <zm-tag v-if="item.versionStage.toLowerCase().indexOf('previous') > -1" type="warning" size="mini">
                                {{ item.versionStage }}: {{ item.versionId.slice(item.versionId.length - 6, item.versionId.length) }}</zm-tag>
                            <zm-tag v-if="item.versionStage.toLowerCase().indexOf('pending') > -1" type="" size="mini">
                                {{ item.versionStage }}: {{ item.versionId.slice(item.versionId.length - 6, item.versionId.length) }}</zm-tag>
                            <zm-tag v-if="item.versionStage.toLowerCase().indexOf('revoked') > -1" size="mini">
                                {{ item.versionStage }}: {{ item.versionId.slice(item.versionId.length - 6, item.versionId.length) }}</zm-tag>
                        <!-- </zm-tooltip> -->
                        </div>
                    </template>
                </zm-table-column>
                <!-- <zm-table-column prop="description" label="Description" show-overflow-tooltip></zm-table-column> -->
                <zm-table-column width="230px" prop="operation">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <!-- <zm-button size="small" class="btn-contain" type="icon" title="show secrets" icon="zm-icon-eyes" @click="showSecrets()"></zm-button> -->
                        <zm-button size="small" class="btn-contain" type="icon" title="delete secrets" icon="zm-icon-delete" @click="deleteSecret(deleteIds)" :disabled="!deleteIds.length"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="add versions" icon="zm-icon-version" @click="batchAddVersion()" :disabled="!deleteIds.length"
                        :loading="!(!uploadingCount && !uploadingIndex)"></zm-button>
                    </template>
                    <template slot-scope="scope" v-if="list.length">
                        <zm-button size="small" type="icon" :icon="scope.row.showHash ? 'zm-icon-eyes' : 'zm-icon-eyes-close'"
                        title="show secret" @click="showSecret(scope.row.id)" :loading="scope.row.loading" v-if="!saferDisplay"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-edit" v-if="buttonPermission(scope.row.applicationId, scope.row.isSensitive) && scope.row.keyType !== 'ENCRYPT'"
                        title="edit attribute" @click="showEdit(scope.row)" :loading="scope.row.loading"></zm-button>
                        <!-- <zm-dropdown class="btn-contain" style="margin: 0 0 0 8px;" @command="handleCommand"
                        v-if="buttonPermission(scope.row.applicationId, scope.row.isSensitive) && scope.row.keyType !== 'ENCRYPT'" trigger="click">
                            <zm-button type="icon" icon="zm-icon-edit" class="btn-contain"></zm-button>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item :command="{command: 'showForceUpdate', param: scope.row}" v-if="scope.row.shareType === 'NORMAL' || scope.row.shareType === 'SHARE'">
                                    Force Update Secret
                                </zm-dropdown-item>
                                <zm-dropdown-item :command="{command: 'showEdit', param: scope.row}">
                                    Edit Attribute
                                </zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown> -->
                        <zm-button size="small" type="icon" icon="zm-icon-delete" title="delete secret"
                        v-if="buttonPermission(scope.row.applicationId, scope.row.isSensitive)"
                        @click="deleteSecret([scope.row.id])"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-version" title="version list"
                        @click="showVersionList(scope.row)"></zm-button>
                        <zm-dropdown class="btn-contain" style="margin: 0 0 0 8px;" @command="handleMoreCommand" trigger="click">
                            <zm-button type="icon" icon="zm-icon-more" class="btn-contain"></zm-button>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item :command="{command: 'showCheck', param: scope.row.secretHashValue}">
                                    Verify Secret Value
                                </zm-dropdown-item>
                                <zm-dropdown-item :command="{command: 'showRefer', param: scope.row.id}" v-if="scope.row.shareType === 'SHARE'">
                                    Show Referenced
                                </zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown>
                        <!-- <zm-button size="small" type="icon" icon="zm-icon-edit" title="force update secret"
                        @click="showForceUpdate(scope.row.id)"></zm-button> -->
                        <!-- <zm-button size="small" type="icon" icon="zm-icon-success-outline" title="check value" @click="showCheck(scope.row.secretHashValue)"></zm-button>
                        <zm-button v-if="scope.row.shareType === 'SHARE'" size="small" type="icon" icon="zm-icon-link" title="show referenced" @click="showRefer(scope.row.id)"></zm-button> -->
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="fetchData"
                    @size-change="handleSizeChange"
                    :current-page.sync="filter.pageNo"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="filter.pageSize"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="total">
                </zm-pagination>
            </div>
        </div>
        </div>
    </div>
    <div v-else>
        <zm-row>
            <zm-button type="text" icon="zm-icon-left" @click="showShareRange = false">Back</zm-button>
        </zm-row>
        <secret-share-range></secret-share-range>
    </div>
        <zm-dialog :title="form.title" :visible.sync="form.visible">
            <!-- <zm-form class="layui-form" style="display:none">
            <input type="text"/>
            <input type="password"/>
            </zm-form> -->
            <zm-form :model="form" label-position="left" ref="form" :rules="rules" label-width="180px">
                <zm-form-item label="Namespace" prop="namespace" v-if="form.title === 'Create'">
                    {{ form.namespace }}
                </zm-form-item>
                <zm-form-item label="Application" prop="applicationId" v-if="form.title === 'Create'">
                    <zm-select v-model="form.applicationId" placeholder="Application" filterable clearable @change="handelAppChange()">
                        <zm-option v-for="item in applicationList" :key="item.id" :label="item.applicationName" :value="item.id"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="PrefixPath" prop="prefixPath" v-if="form.title === 'Create'">
                    <zm-select v-for="(item, index) in form.prefixPath" :key="index" v-model="form.prefixPath[index]" filterable allow-create clearable
                        @change="handlePrefixChange(index, 'form')" class="select-inline">
                        <zm-option v-for="item in pathList.form[index]" :key="item.id" :label="item.path" :value="item.path"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="FullPath" prop="fullPath" v-if="form.title === 'Edit'">
                    {{ form.fullPath }}
                </zm-form-item>
                <zm-form-item label="Alias" prop="alias">
                    <zm-input size="small" v-model="form.alias" :disabled="form.title === 'Edit'"></zm-input>
                </zm-form-item>
                <zm-form-item label="Group" prop="groupName">
                    <zm-input type="text" size="small" readonly onblur="this.setAttribute('readonly', true)" id="create-group" name="creategroup"
                        onfocus="this.removeAttribute('readonly')" autocomplete="off" v-model="form.groupName"></zm-input>
                </zm-form-item>
                <!-- <zm-form-item label="Description" prop="description">
                    <zm-input type="textarea" size="small" v-model="form.description"></zm-input>
                </zm-form-item> -->
                <zm-form-item label="Key Type" prop="type">
                    <zm-radio-group size="small" v-model="form.keyType" :disabled="form.title === 'Edit'">
                        <zm-radio label="ENCRYPT">Encrypt</zm-radio>
                        <zm-radio label="COMMON">Common</zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="isEnable">
                    <div slot="label">isEnable
                        <zm-tooltip class="item" content="If the value is false, api will not return this secret."
                        placement="bottom" popper-class="strictmode-popper">
                            <span><i class="zm-icon-help-outline zm-input__icon" style="line-height: 10px;"></i></span>
                        </zm-tooltip>
                    </div>
                    <zm-switch v-model="form.isEnable"></zm-switch>
                </zm-form-item>
                <zm-form-item label="isSensitive" v-if="form.keyType === 'COMMON'">
                    <zm-switch v-model="form.isSensitive" :disabled="form.title === 'Edit'"></zm-switch>
                </zm-form-item>
                <zm-form-item label="Share Type" prop="sharetype" v-if="form.keyType === 'COMMON'">
                    <zm-radio-group size="small" v-model="form.shareType">
                        <zm-radio label="NORMAL">Normal</zm-radio>
                        <zm-radio label="SHARE">Share</zm-radio>
                        <zm-radio label="REFERENCE">Reference</zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="Length(bit)" v-if="form.keyType === 'ENCRYPT'">
                    <zm-input-number v-model="form.length" :min="1" :max="1024"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="Empty" v-if="(form.title === 'Create' && form.keyType !== 'ENCRYPT' && form.shareType !== 'REFERENCE') ||
                (form.title === 'Edit' && form.oldType === 'REFERENCE' && form.shareType !== 'REFERENCE')">
                    <zm-switch v-model="form.isEmpty"></zm-switch>
                </zm-form-item>
                <zm-form-item label="Default" v-if="form.keyType === 'ENCRYPT'">
                    <zm-switch v-model="form.isdefault"></zm-switch>
                </zm-form-item>
                <zm-form-item label="Input Type"
                    v-if="((form.title === 'Create' && form.keyType === 'COMMON' && form.shareType !== 'REFERENCE') ||
                    (form.title === 'Edit' && form.oldType === 'REFERENCE' && form.shareType !== 'REFERENCE')) && !form.isEmpty">
                    <zm-radio-group size="small" v-model="form.secretType">
                        <zm-radio label="text">Text</zm-radio>
                        <zm-radio label="file">File</zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="Secret" :prop="form.secretType === 'file' && form.keyType !== 'ENCRYPT' ? '' : 'secret'"
                    v-if="(((form.title === 'Create' && form.keyType === 'COMMON' && form.shareType !== 'REFERENCE') ||
                    (form.title === 'Edit' && form.oldType === 'REFERENCE' && form.shareType !== 'REFERENCE')) && !form.isEmpty) ||
                    (form.keyType === 'ENCRYPT' && form.isdefault)">
                    <zm-input v-if="form.secretType === 'text' || form.keyType === 'ENCRYPT'" type="textarea" size="small" v-model="form.secret"></zm-input>
                    <zm-upload
                        v-if="form.secretType === 'file' && form.keyType !== 'ENCRYPT'"
                        :action="getAction()"
                        ref="upload"
                        id="demo-upload"
                        :file-list="fileList"
                        :headers="headers"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        :on-change="beforeRemove"
                        :data="form"
                        :auto-upload="false"
                        :http-request="secretUpload"
                        >
                        <zm-button size="small" type="primary">click to upload</zm-button>
                        <div slot="tip" class="zm-upload__tip">limited in 65535 byte</div>
                    </zm-upload>
                </zm-form-item>
                <zm-form-item label="Assign To Application" prop="sharedApplicationIds" v-if="form.shareType === 'SHARE' && form.keyType === 'COMMON'">
                    <zm-cascader v-model="form.sharedApplicationIds" style="width: 100%"
                        :options="sharedApplicationList"
                        filterable
                        @visible-change="handleSharedAllFocus"
                        :props="{ multiple: true, emitPath: false }" clearable placeholder=""></zm-cascader>
                </zm-form-item>
                <zm-form-item label="ReferencedSecretId" prop="referenceSecretId" v-if="((form.title === 'Create' && form.keyType === 'COMMON') ||
                (form.title === 'Edit')) && form.shareType === 'REFERENCE'">
                    {{ form.referenceSecretId }}
                    <zm-button type="text" @click="showReferenceList">click to choose</zm-button>
                </zm-form-item>
                <!-- <zm-form-item label="File" v-if="form.keyType === 'BINARY'">
                </zm-form-item> -->
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="form.visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Share Secret" :visible.sync="referenceVisible" show-close>
            <div class="table-container">
                <zm-form :inline="true">
                    <zm-form-item label="Full Path">
                        <zm-input v-model="referenceFilter.fullPath" style="width: 150px" @keyup.enter.native="showReferenceList" clearable></zm-input>
                    </zm-form-item>
                    <zm-form-item label="Alias">
                        <zm-input v-model="referenceFilter.alias" style="width: 150px" @keyup.enter.native="showReferenceList" clearable></zm-input>
                    </zm-form-item>
                    <zm-button type="primary" plain class="zm-icon-search" @click="showReferenceList"></zm-button>
                </zm-form>
                <zm-table :data="referenceList" v-loading="loading" @selection-change="handleSelectionChange" ref="multipleTable" id="secretDialogTable">
                    <zm-table-column type="selection" width="55"> </zm-table-column>
                    <zm-table-column prop="alias" label="Alias" show-overflow-tooltip></zm-table-column>
                    <zm-table-column prop="fullPath" label="Full Path" show-overflow-tooltip></zm-table-column>
                </zm-table>
                <div style="text-align: center" class="pagination-wrap">
                    <zm-pagination @current-change="showReferenceList"
                        @size-change="handleReferenceSizeChange"
                        :current-page.sync="referenceFilter.pageNo"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="referenceFilter.pageSize"
                        layout="sizes, total, prev, pager, next"
                        :pager-count="5"
                        :total="referenceFilter.total">
                    </zm-pagination>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="referenceVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="submitReferenceSecret" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Failed List" :visible.sync="failedVisible" show-close>
            <div class="table-container">
                <zm-table :data="failedList">
                    <zm-table-column prop="prefixPath" label="Prefix Path" v-if="failedList[0] && (failedList[0].prefixPath || !failedList[0].secretId)"></zm-table-column>
                    <zm-table-column prop="alias" label="Alias" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.alias ? scope.row.alias : 'secretId: ' + scope.row.secretId }}
                        </template>
                    </zm-table-column>
                    <zm-table-column prop="message" label="Message" show-overflow-tooltip></zm-table-column>
                </zm-table>
            </div>
        </zm-dialog>
        <zm-dialog title="Secret" :visible.sync="secretVisible" show-close>
            <div v-for="(item, index) in secret.split('\n')" :key="index" style="word-break: break-all;">{{ item }}</div>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" type="primary" @click="secretVisible = false">Close</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Force Update Secret" :visible.sync="forceUpdateVisible" show-close>
            <zm-form label-width="120px">
                <zm-form-item label="Alias">{{ forceUpdateForm.alias }}
                </zm-form-item>
                <zm-form-item label="Input Type">
                    <zm-radio-group size="small" v-model="forceUpdateForm.secretType">
                        <zm-radio label="text">Text</zm-radio>
                        <zm-radio label="file">File</zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="Secret" :prop="forceUpdateForm.secretType === 'file' ? '' : 'secret'">
                    <zm-input v-if="forceUpdateForm.secretType === 'text'" type="textarea" size="small" v-model="forceUpdateForm.secret"></zm-input>
                    <zm-upload
                        v-if="forceUpdateForm.secretType === 'file'"
                        :action="getUpdateAction()"
                        ref="updateUpload"
                        id="demo-upload"
                        :file-list="forceUpdateForm.fileList"
                        :headers="headers"
                        :on-success="updateUploadSuccess"
                        :on-error="updateUploadError"
                        :data="forceUpdateForm"
                        :auto-upload="false"
                        :http-request="updateUpload"
                        >
                        <zm-button size="small" type="primary">click to upload</zm-button>
                        <div slot="tip" class="zm-upload__tip">limited in 65535 byte</div>
                    </zm-upload>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="forceUpdateVisible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="forceUpdateSecret" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog :title="searchHashForm.title" :visible.sync="searchHashForm.visible" show-close>
            <zm-form label-width="120px">
                <zm-form-item label="Input Type">
                    <zm-radio-group size="small" v-model="searchHashForm.secretType">
                        <zm-radio label="text">Text</zm-radio>
                        <zm-radio label="file">File</zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="Secret" :prop="searchHashForm.secretType === 'file' ? '' : 'secret'">
                    <zm-input v-if="searchHashForm.secretType === 'text'" type="textarea" size="small"
                    v-model="searchHashForm.secret"></zm-input>
                    <zm-upload
                        v-if="searchHashForm.secretType === 'file'"
                        :action="getHashAction()"
                        ref="hashUpload"
                        id="demo-upload"
                        :file-list="searchHashForm.fileList"
                        :headers="headers"
                        :on-success="hashUploadSuccess"
                        :on-error="hashUploadError"
                        :data="searchHashForm"
                        :auto-upload="false"
                        >
                        <zm-button size="small" type="primary">click to upload</zm-button>
                        <div slot="tip" class="zm-upload__tip">limited in 65535 byte</div>
                    </zm-upload>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="searchHashForm.visible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="hashSecret" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Duplicate Secrets" :visible.sync="duplicateForm.visible">
            <zm-form label-position="left" label-width="180px">
                <zm-form-item label="Source Path">
                    {{ duplicateForm.sourcePath }}
                </zm-form-item>
                <zm-form-item label="Target Path" prop="prefixPath">
                    {{ duplicateForm.namespace }}/{{ duplicateForm.applicationName }}
                    <span v-for="(item, index) in duplicateForm.prefixPath" :key="index">/
                    <zm-select v-model="duplicateForm.prefixPath[index]" filterable allow-create clearable
                        @change="handlePrefixChange(index, 'duplicateForm')" class="select-inline">
                        <zm-option v-for="item in pathList.duplicateForm[index]" :key="item.id" :label="item.path" :value="item.path"></zm-option>
                    </zm-select>
                    </span>
                </zm-form-item>
                <zm-form-item label="Secrets" v-if="duplicateForm.selectedSecrets.length">
                    <zm-tag size="medium"
                        class="input-tag"
                        :key="tag.id"
                        v-for="tag in duplicateForm.selectedSecrets"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(tag)">
                        {{ tag.alias }}
                    </zm-tag>
                </zm-form-item>
            </zm-form>
            <span style="color: #0E71EB">*This function only supports duplicating secrets under the current path, excluding sub paths</span>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="duplicateForm.visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="saveDuplicate()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Duplicate Result" :visible.sync="duplicateResult.visible" show-close>
            <zm-table :show-header="false"
            :data="duplicateResult.result.slice((duplicateResult.pageNo - 1) * duplicateResult.pageSize, duplicateResult.pageNo * duplicateResult.pageSize)">
                <zm-table-column label="key" prop="key"></zm-table-column>
                <zm-table-column label="value" prop="value"></zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination
                    :current-page.sync="duplicateResult.pageNo"
                    :page-size="duplicateResult.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="duplicateResult.result.length">
                </zm-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="duplicateResult.visible = false">Cancel</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Complete Rotate" :visible.sync="completeRotateVisible" show-close>
            <zm-form>
                <zm-form-item label="Version Stage">
                    <zm-radio-group v-model="completeRotateForm.versionStage">
                        <zm-radio>current</zm-radio>
                        <zm-radio>revoke</zm-radio>
                    </zm-radio-group>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="completeRotateVisible = false">Cancel</zm-button>
                <zm-button size="small" @click="completeRotateVisible = false" type="primary" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Batch Update" :visible.sync="updateTemplate.visible" show-close>
            <zm-form label-width="120px">
                <zm-form-item label="Action">
                    <zm-select size="small" v-model="updateTemplate.action">
                        <zm-option v-for="item in actionList" :key="item" :label="item" :value="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="File">
                    <zm-upload
                        :action="getUploadForBatchUpdateAction()"
                        ref="batchUpload"
                        :file-list="updateTemplate.fileList"
                        :headers="headers"
                        :on-success="batchUploadSuccess"
                        :on-error="batchUploadError"
                        :data="updateTemplate"
                        :auto-upload="false"
                        >
                        <zm-button size="small" type="primary">click to upload</zm-button>
                        <div slot="tip" class="zm-upload__tip">limited in 65535 byte</div>
                    </zm-upload>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="updateTemplate.visible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="updateBatch" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Batch Update Result" :visible.sync="batchUpdateResult.visible" width="80%" v-if="batchUpdateResult.visible">
            <update-result :result="batchUpdateResult" :action="updateTemplate.action" ref="updateResult"></update-result>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="closeUpdateResult">Close</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Confirm Add New Version" :visible.sync="batchAddVersionForm.visible" show-close append-to-body>
            Please repeat action to confirm operation of <em>AddNewVersion</em>
            <zm-form label-width="150px">
                <zm-form-item label="repeat action">
                    <zm-input v-model.trim="batchAddVersionForm.repeatAction"></zm-input>
                </zm-form-item>
                <zm-form-item label="Input Type">
                    <zm-radio-group v-model="batchAddVersionForm.secretType">
                        <zm-radio label="text">Text</zm-radio>
                        <zm-radio label="file">File</zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="Secret" :prop="batchAddVersionForm.secretType === 'file' ? '' : 'secret'">
                    <zm-input v-if="batchAddVersionForm.secretType === 'text'" type="textarea" size="small" v-model="batchAddVersionForm.secret"></zm-input>
                    <zm-upload
                        v-if="batchAddVersionForm.secretType === 'file'"
                        :action="getAddVersionAction()"
                        ref="addVersionUpload"
                        id="demo-upload"
                        :file-list="batchAddVersionForm.fileList"
                        :headers="headers"
                        :data="batchAddVersionForm"
                        :http-request="addVersionUpload"
                        >
                        <zm-button size="small" type="primary">click to upload</zm-button>
                        <div slot="tip" class="zm-upload__tip">limited in 65535 byte</div>
                    </zm-upload>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="batchAddVersionForm.visible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="doSend">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Result" :visible.sync="batchAddResultForm.visible" show-close>
            <zm-table :data="batchAddResultForm.result">
                <zm-table-column label="fullPath" prop="path"></zm-table-column>
                <zm-table-column label="msg" prop="msg"></zm-table-column>
            </zm-table>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="batchAddResultForm.visible = false">Close</zm-button>
            </div>
        </zm-dialog>
        <!-- <zm-dialog title="Version List" :visible.sync="versionListVisible" show-close>
            <version-list></version-list>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="versionListVisible = false">Close</zm-button>
            </div>
        </zm-dialog> -->
    </div>
</template>
<script>
import {
    getSecretList,
    createSecret,
    deleteSecret,
    listApplication,
    listPath,
    downloadTemplate,
    downloadUpdateTemplate,
    downloadMetadata,
    getShareKeyList,
    listNamespace,
    forceUpdateSecret,
    getSecret,
    hashSecret,
    duplicateSecret,
    listBaseInfo,
    verifySecretVersion
} from '@/api/index'
import { addVersion } from '@/api/version'
import { getPermission } from '@/api/permission'
import axios from 'axios'
import VersionList from './versionList'
import updateResult from '@/components/updateResult'
import secretShareRange from './secretShareRange'
export default {
    name: 'secret',
    props: ['isHashComponent', 'secretList'],
    components: {
        VersionList,
        secretShareRange,
        updateResult
    },
    data () {
        var validateAlias = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('please enter alias'))
            } else {
                var reg = /^[^/@\s]*$/
                if (reg.test(value) && value.length <= 64) {
                    callback()
                }
                callback(new Error('invalid alias!'))
            }
        }
        return {
            permission: {
                isSuperAdmin: false,
                isSuperOperator: false,
                manageableResources: []
            },
            saferDisplay: localStorage.saferDisplay === 'true',
            initDisplayedColumn: {
                key: 'csms-secret-table',
                props: ['alias', 'keyType', 'shareType', 'fullPath', 'hash', 'isEnable', 'isSensitive', 'operation']
            },
            showShareRange: false,
            list: [],
            namespaceList: [],
            namespace: localStorage.namespace,
            applicationList: [],
            pathList: {
                filter: [[]],
                duplicateForm: [[]],
                form: [[]]
            },
            total: 0,
            loading: false,
            sharedApplicationList: [],
            filter: {
                applicationId: '',
                prefixPath: [],
                alias: '',
                secretHashValue: '',
                referenceSecretId: '',
                searchBy: '',
                strict: false,
                inRevoke: null,
                pageSize: 10,
                pageNo: 1
            },
            tempFilter: {
                applicationList: [],
                namespace: '',
                applicationId: '',
                prefixPath: [],
                alias: '',
                secretHashValue: '',
                strict: false
            },
            searchHashForm: {
                visible: false,
                secretType: 'text',
                fileList: [],
                hashValue: '',
                secret: ''
            },
            updateTemplate: {
                visible: false,
                fileList: [],
                action: ''
            },
            actionList: ['UpdateVersionToCurrent', 'RevokeVersion', 'UpdateSecretToShare', 'UpdateSecretToReference'],
            batchUpdateResult: {
                visible: false,
                data: [],
                success: false
            },
            loadingVerify: false,
            deleteIds: [],
            headers: {
                Authorization: 'Bearer ' + localStorage.token
            },
            form: {
                title: '',
                oldType: '',
                visible: false,
                id: '',
                namespace: '',
                applicationId: '',
                prefixPath: [],
                groupName: '',
                alias: '',
                description: '',
                keyType: '',
                shareType: '',
                secretType: 'text',
                secret: '',
                length: 256,
                isdefault: false,
                isEmpty: false,
                isSensitive: true,
                isEnable: true,
                sharedApplicationIds: [],
                referenceSecretId: ''
            },
            duplicateForm: {
                visible: false,
                selectedSecrets: [],
                namespace: '',
                applicationId: '',
                applicationName: '',
                prefixPath: [],
                secretIds: [],
                sourcePath: '',
                targetPath: ''
            },
            duplicateResult: {
                visible: false,
                result: [],
                pageNo: 1,
                pageSize: 10
            },
            referenceSecretId: '',
            uploading: false,
            fileList: [],
            uploadSecretData: {},
            failedList: [],
            failedVisible: false,
            referenceVisible: false,
            referenceList: [],
            referenceFilter: {
                fullPath: '',
                alias: '',
                pageSize: 10,
                pageNo: 1,
                total: 0
            },
            secretVisible: false,
            secret: '',
            forceUpdateVisible: false,
            forceUpdateForm: {
                id: '',
                alias: '',
                secretType: 'text',
                fileList: [],
                secret: ''
            },
            downloadMetadataLoading: false,
            completeRotateVisible: false,
            completeRotateForm: {
                versionStage: ''
            },
            versionListVisible: false,
            versionSecret: {},
            rules: {
                alias: [
                    { required: true, validator: validateAlias, trigger: 'blur' }
                ],
                // groupName: [
                //     { required: true, message: 'please input groupName', trigger: 'blur' }
                // ],
                // prefixPath: [
                //     { required: true, message: 'please input prefixPath', trigger: 'blur' }
                // ],
                secret: [
                    { required: true, message: 'please input secret', trigger: 'blur' }
                ]
            },
            selectLines: [],
            uploadingCount: 0,
            uploadingIndex: 0,
            batchAddVersionForm: {
                visible: false,
                repeatAction: '',
                secretType: '',
                secret: '',
                fileList: []
            },
            batchAddResultForm: {
                visible: false,
                result: []
            }
        }
    },
    watch: {
        uploadingCount () {
            if (!this.uploadingCount) {
                this.uploadingIndex++
                this.batchAdd()
            }
        },
        namespace () {
            this.filter.applicationId = ''
            this.list = []
            this.applicationList = []
            this.filter.prefixPath = []
            localStorage.application = ''
            // this.fetchApplication()
        },
        'filter.applicationId' () {
            this.setURL()
        },
        'filter.prefixPath' () {
            this.setURL()
        },
        'filter.alias' () {
            this.setURL()
        },
        'filter.secretHashValue' () {
            this.setURL()
        },
        'filter.referenceSecretId' () {
            this.setURL()
        },
        'filter.searchBy' () {
            this.setURL()
        },
        'filter.strict' () {
            this.setURL()
        },
        'filter.pageSize' () {
            this.setURL()
        },
        'filter.pageNo' () {
            this.setURL()
        }
    },
    computed: {
        showSecretsVisible () {
            var data = false
            this.list.map(item => {
                if (!item.showHash) {
                    data = true
                }
            })
            return data
        },
        showSecretsLoading () {
            var data = false
            this.list.map(item => {
                if (item.loading) {
                    data = true
                }
            })
            return data
        },
        uploadData () {
            var prefixPath = this.filter.prefixPath[0] || ''
            for (var i = 1; i < this.filter.prefixPath.length; i++) {
                prefixPath += this.filter.prefixPath[i] ? '/' + this.filter.prefixPath[i] : ''
            }
            return {
                namespace: localStorage.namespace,
                applicationId: this.filter.applicationId,
                prefixPath: prefixPath
            }
        }
    },
    created () {
        this.fetchNamespace()
        this.fetchDataPermission()
        this.fetchPermission()
        // this.filter.applicationId = localStorage.application
        if (this.$route.query.secretHashValue) {
            this.filter.secretHashValue = this.$route.query.secretHashValue
            this.filter.searchBy = 'hash'
            this.filter.applicationId = ''
            this.namespace = ''
        }
        localStorage.path = this.$route.path
        localStorage.params = ''
        console.log(this.$route.query.params)
        if (this.$route.query.params && this.$route.query.params !== 'undefined') {
            this.filter = JSON.parse(this.$route.query.params)
            if (this.namespace) {
                const applicationId = this.filter.applicationId
                this.filter.applicationId = ''
                listApplication(this.namespace, '', 'secret/secret').then(response => {
                    this.applicationList = response.data
                    this.applicationList.map(item => {
                        if (item.id === applicationId) {
                            this.filter.applicationId = applicationId
                        }
                    })
                    if (this.filter.applicationId) {
                        this.fetchData()
                        for (let i = 0; i <= this.filter.prefixPath.length; i++) {
                            var parentFullPath = i ? this.filter.prefixPath[0] : ''
                            this.pathList.filter[i] = []
                            for (var j = 1; j < this.filter.prefixPath.length && j < i; j++) {
                                parentFullPath += (i > j && this.filter.prefixPath[j]) ? '/' + this.filter.prefixPath[j] : ''
                            }
                            const data = {
                                namespace: this.namespace,
                                applicationId: this.filter.applicationId,
                                parentFullPath: parentFullPath
                            }
                            listPath(data).then(res => {
                                this.pathList.filter[i] = res.data
                                if (this.filter.prefixPath[this.filter.prefixPath.length - 1] && res.data.length) {
                                    this.pathList.filter.push([])
                                }
                            })
                        }
                    }
                })
            }
        } else {
        this.fetchApplication(true)
        }
        // window.addEventListener('setItem', () => {
        //     this.namespace = localStorage.getItem('namespace')
        // })
        // this.namespace = localStorage.namespace
        // this.fetchNamespace()
        // if (this.filter.applicationId) {
            // this.filter.prefixPath = ['']
            // this.fetchData()
        // }
    },
    methods: {
        setURL () {
            const data = this.filter
            var url = `${location.href.split('?params=')[0]}?params=${JSON.stringify(data)}`
            history.pushState({ url: url }, '', url)
            localStorage.params = JSON.stringify(data)
        },
        fetchDataPermission () {
            listBaseInfo().then(response => {
                this.sharedApplicationList = response.data.map(namespace => {
                    return {
                        label: namespace.namespace,
                        value: namespace.namespace,
                        children: namespace.children.map(app => {
                            return {
                                label: app.name,
                                value: app.id
                            }
                        })
                    }
                })
                this.sharedApplicationList.unshift({
                    label: 'all',
                    value: 'all'
                    // children: [{
                    //     label: '*',
                    //     value: '*'
                    // }]
                })
            })
        },
        handleSharedAllFocus (e) {
            console.log(e)
            if (e && this.sharedApplicationList[0].value === 'all') {
                this.sharedApplicationList.shift()
            } else {
                this.sharedApplicationList.unshift({
                    label: 'all',
                    value: 'all'
                })
            }
        },
        fetchPermission () {
            getPermission('secret/secret').then(response => {
                this.permission.isSuperAdmin = response.data.isSuperAdmin
                this.permission.isSuperOperator = response.data.isSuperOperator
                response.data.manageableResources.map(item => {
                    const data = item.split('/')
                    const appData = data[0].split(':')[1].split('|')
                    const secretData = data.length > 1 ? data[1].split(':')[1].split('|') : ['sensitive', 'insensitive']
                    appData.map(app => {
                        secretData.map(secret => {
                            this.permission.manageableResources.push(app + '-' + secret)
                        })
                    })
                })
            })
        },
        selectPermission (row, index) {
            const isSensitive = row.isSensitive ? 'sensitive' : 'insensitive'
            return this.permission.manageableResources.indexOf(row.applicationId + '-' + isSensitive) > -1 || this.permission.manageableResources.indexOf('*-' + isSensitive) > -1
        },
        buttonPermission (appId, secret) {
            const isSensitive = secret ? 'sensitive' : 'insensitive'
            return this.permission.manageableResources.indexOf(appId + '-' + isSensitive) > -1 || this.permission.manageableResources.indexOf('*-' + isSensitive) > -1
        },
        showCloseRotate (row) {
            this.versionListVisible = true
            row.isInRevoke = false
            row.isFinishedRotate = false
        },
        showCompleteRotate (row) {
            row.isFinishedRotate = true
            this.completeRotateVisible = true
        },
        showVersionList (row) {
            this.versionSecret = row
            this.versionListVisible = true
        },
        fetchNamespace () {
            if (localStorage.namespaceList) {
                this.namespaceList = JSON.parse(localStorage.namespaceList)
            } else {
                listNamespace().then(response => {
                    this.namespaceList = response
                })
            }
        },
        setNamespace (val) {
            localStorage.namespace = val
            console.log(val)
            // this.resetSetItem('namespace', this.value)
            if (val) {
                this.fetchApplication()
            } else {
                this.filter.applicationId = ''
            }
            this.fetchData()
        },
        getAction () {
            return process.env.VUE_APP_API_URL + 'backend/secret/save'
        },
        getUserAction () {
            return process.env.VUE_APP_API_URL + 'backend/secret/upload'
        },
        getUpdateAction () {
            return process.env.VUE_APP_API_URL + 'backend/secret/forceUpdate'
        },
        getHashAction () {
            return process.env.VUE_APP_API_URL + 'backend/secret/hashSecret'
        },
        getUploadForBatchUpdateAction () {
            return process.env.VUE_APP_API_URL + 'backend/secret/uploadForBatchUpdate'
        },
        showUpdateTemplate (command) {
            this.updateTemplate.action = command
            var btn = document.getElementById('update-upload')
            btn.click()
            // this.updateTemplate.visible = true
        },
        batchUploadSuccess (response, file) {
            this.loading = false
            this.batchUpdateResult.success = response.body.success
            this.batchUpdateResult.data = response.body.data
            this.$refs.batchUpload.clearFiles()
            this.updateTemplate.visible = false
            this.batchUpdateResult.visible = true
            // if (response.body.success) {
            //     console.log(response)
            // } else {
            //     this.$message.error(response)
            // }
        },
        batchUploadError (err, file, fileList) {
            this.loading = false
            this.$refs.batchUpload.clearFiles()
            this.$message.error(err)
        },
        closeUpdateResult () {
            const allSuccessed = this.$refs.updateResult.data.filter(item => {
                return !item.hasSuccess
            }).length
            if (!allSuccessed || !this.batchUpdateResult.success) {
                this.batchUpdateResult.visible = false
                this.fetchData()
            } else {
                this.$confirm('There still requestEntity not sent. Close?', 'Warning', {
                    confirmButtonText: 'Close',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.batchUpdateResult.visible = false
                    this.fetchData()
                }).catch(() => {
                    this.$message.info('Close dialog canceled')
                })
            }
        },
        myUpload (content) {
            console.log(content)
            const formData = new FormData()
            formData.append('file', content.file)
            formData.append('applicationId', content.data.applicationId)
            formData.append('namespace', content.data.namespace)
            formData.append('prefixPath', content.data.prefixPath)
            this.uploading = true
            axios({
                method: 'post',
                url: content.action,
                headers: content.headers,
                timeout: 120000,
                data: formData
            }).then(res => {
                this.uploading = false
                content.onSuccess(res)
            }).catch(err => {
                this.uploading = false
                content.onError(err)
            })
        },
        onSuccess (res, file) {
            if (res.data.success) {
                this.$message({
                    type: res.data.failedNum ? 'warning' : 'success',
                    message: 'Success:' + res.data.successNum + ', Failed:' + res.data.failedNum
                })
                if (this.filter.applicationId) {
                    this.fetchData()
                    this.refreshPath()
                }
                if (res.data.failedList.length) {
                    this.failedList = res.data.failedList
                    this.failedVisible = true
                }
            }
        },
        onError (err, file) {
            this.$message({
                type: 'error',
                message: err.response.data.errorMessage
            })
        },
        uploadSuccess (response, file) {
            this.loading = false
            if (response) {
                this.$message.success('Create success!')
                this.$refs.upload.clearFiles()
                this.form.visible = false
                this.fetchData()
                this.refreshPath()
            } else {
                this.$message.error(response)
            }
        },
        uploadError (err, file, fileList) {
            this.loading = false
            console.log(file, fileList)
            this.$refs.upload.clearFiles()
            // this.fileList = [file]
            // this.$refs.upload.uploadFiles = [file]
            this.$message.error(err.response.data.errorMessage)
        },
        updateUploadSuccess (response, file) {
            this.loading = false
            if (response) {
                this.$message.success('Update success!')
                this.$refs.updateUpload.clearFiles()
                this.fetchData()
                this.forceUpdateVisible = false
            } else {
                this.$message.error(response)
            }
        },
        updateUploadError (err, file, fileList) {
            this.loading = false
            this.$refs.updateUpload.clearFiles()
            this.$message.error(err.response.data.errorMessage)
        },
        hashUploadSuccess (response, file) {
            this.loading = false
            if (response.body.success) {
                console.log(response)
            if (this.searchHashForm.title === 'Search Secret Value') {
                this.filter.secretHashValue = response.body.secretHashValue
                this.filter.searchBy = 'hash'
                this.fetchData()
                this.$message.success('Hash success!')
                this.$refs.hashUpload.clearFiles()
                this.searchHashForm.visible = false
            } else {
                if (this.searchHashForm.hashValue === response.body.secretHashValue) {
                    this.$message.success('Verify secret success')
                    this.$refs.hashUpload.clearFiles()
                    this.searchHashForm.visible = false
                } else {
                    this.$message.error('Verify secret failed')
                    this.$refs.hashUpload.clearFiles()
                }
            }
            } else {
                this.$message.error(response)
            }
        },
        hashUploadError (err, file, fileList) {
            this.loading = false
            this.$refs.hashUpload.clearFiles()
            this.$message.error(err.response.data.errorMessage)
        },
        beforeRemove (file, fileList) {
            console.log(file, fileList)
        },
        setGroup () {
            this.form.groupName = this.form.groupName ? this.form.groupName : this.form.alias
        },
        handelAppChange (refreshList) {
            localStorage.application = this.filter.applicationId
            if (refreshList) {
                this.filter.prefixPath = ['']
                if (this.filter.applicationId) {
                    const data = {
                        namespace: this.namespace,
                        applicationId: this.filter.applicationId,
                        parentFullPath: ''
                    }
                    listPath(data).then(response => {
                        this.pathList.filter = [response.data, []]
                    })
                }
                this.fetchData()
            } else {
                this.form.prefixPath = ['']
                if (this.form.applicationId) {
                    const data = {
                        namespace: this.namespace,
                        applicationId: this.form.applicationId,
                        parentFullPath: ''
                    }
                    listPath(data).then(response => {
                        this.pathList.form = [response.data, []]
                    })
                }
            }
        },
        handlePrefixChange (index, key, isQuery) {
            console.log(this[key].prefixPath.indexOf(''))
            if (this[key].prefixPath.indexOf('') !== -1) {
                this[key].prefixPath.splice(this[key].prefixPath.indexOf('') + 1)
            }
            console.log(this[key].prefixPath)
            var reg = /[A-Z]/
            if (isQuery || !reg.test(this[key].prefixPath[index])) {
                for (var i = 0; i < this[key].prefixPath.length; i++) {
                    if (index < i) {
                        this[key].prefixPath[i] = ''
                    }
                }
                this.fetchPath(index + 1, this[key].prefixPath, this[key].applicationId, key)
                if (key === 'filter') {
                    this.fetchData()
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: 'Prefix path cannot contain uppercase letters:' + this[key].prefixPath[index]
                })
            }
        },
        fetchApplication (isCreated) {
            this.namespace = this.$route.query.secretHashValue && isCreated ? '' : localStorage.namespace
            if (this.namespace) {
                listApplication(this.namespace, '', 'secret/secret').then(response => {
                    this.applicationList = response.data
                    if (isCreated) {
                        this.applicationList.map(item => {
                            if (item.id === localStorage.application) {
                                this.filter.applicationId = localStorage.application
                            }
                        })
                        this.fetchData()
                    }
                    if (this.filter.applicationId) {
                        const data = {
                            namespace: this.namespace,
                            applicationId: this.filter.applicationId,
                            parentFullPath: ''
                        }
                        listPath(data).then(response => {
                            this.pathList.filter = [response.data, []]
                            this.pathList.form = [response.data, []]
                            this.filter.prefixPath = ['']
                        })
                    }
                })
            } else {
                if (isCreated) {
                    this.fetchData()
                }
            }
        },
        fetchPath (index, prefixPath, applicationId, key) {
            var path = index ? prefixPath[0] : ''
            this.pathList[key][index] = []
            for (var i = 1; i < prefixPath.length && i < index; i++) {
                path += (index > i && prefixPath[i]) ? '/' + this[key].prefixPath[i] : ''
            }
            const data = {
                namespace: this.namespace,
                applicationId: applicationId,
                parentFullPath: path
            }
            listPath(data).then(response => {
                this.pathList[key][index] = response.data
                if (this[key].prefixPath[this[key].prefixPath.length - 1] && (response.data.length || key !== 'filter')) {
                    this[key].prefixPath.push('')
                    this.pathList[key].push([])
                }
            }).catch(err => {
                if (err.response.status === 404) {
                    localStorage.application = ''
                    this[key].applicationId = ''
                }
                this.loading = false
            })
        },
        verifySecretVersion () {
            if (this.namespace && this.filter.applicationId && this.filter.alias) {
                var applicationName = ''
                this.applicationList.map(item => {
                    if (item.id === this.filter.applicationId) {
                        applicationName = item.applicationName
                    }
                })
                var prefixPath = applicationName ? this.namespace + '/' + applicationName : this.namespace
                for (var i = 0; i < this.filter.prefixPath.length; i++) {
                    prefixPath += this.filter.prefixPath[i] ? '/' + this.filter.prefixPath[i] : ''
                }
                const { alias } = this.filter
                this.loadingVerify = true
                const data = { prefixPath, alias }
                verifySecretVersion(data).then(response => {
                    this.$message.success('Verify version success')
                    this.loadingVerify = false
                }).catch(() => {
                    this.loadingVerify = false
                })
            } else {
                this.$message.warning('Namespace, application, alias are required')
            }
        },
        fetchData () {
            var applicationName = ''
            this.applicationList.map(item => {
                if (item.id === this.filter.applicationId) {
                    applicationName = item.applicationName
                }
            })
            console.log(applicationName)
            var prefixPath = applicationName ? this.namespace + '/' + applicationName : this.namespace
            for (var i = 0; i < this.filter.prefixPath.length; i++) {
                prefixPath += this.filter.prefixPath[i] ? '/' + this.filter.prefixPath[i] : ''
            }
            const { applicationId, alias, pageSize, pageNo, secretHashValue, referenceSecretId, searchBy, strict, inRevoke } = this.filter
            this.list = []
            // if (applicationId || secretHashValue || referenceSecretId) {
                if ((!searchBy || searchBy === 'hash') && !secretHashValue) {
                    this.loading = true
                    const data = { prefixPath, applicationId, alias, pageSize, pageNo, strict, inRevoke }
                    getSecretList(data).then(response => {
                        this.list = []
                        response.data.map(item => {
                            this.list.push({
                                alias: item.alias,
                                applicationId: item.applicationId,
                                description: item.description,
                                fullPath: item.fullPath,
                                group: item.group,
                                id: item.id,
                                isEnable: item.isEnable,
                                isSensitive: item.isSensitive,
                                isInRevoke: item.isInRevoke,
                                isFinishedRotate: item.isFinishedRotate,
                                keyType: item.keyType,
                                secretHashValue: item.secretHashValue,
                                shareType: item.shareType,
                                referenceSecretId: item.referenceSecretId,
                                referenceSecretName: item.referenceSecretName,
                                sharedApplicationIds: item.sharedApplicationIds,
                                versionInfos: item.versionInfos,
                                secret: '',
                                loading: false,
                                showHash: true
                            })
                        })
                        this.total = response.total
                        this.loading = false
                    }).catch(err => {
                        if (err.response.status === 404) {
                            localStorage.application = ''
                            this.filter.applicationId = ''
                        }
                        this.loading = false
                    })
                } else if (searchBy === 'hash' || (!searchBy && secretHashValue)) {
                    this.loading = true
                    const data = { prefixPath, applicationId, alias, pageSize, pageNo, secretHashValue, strict, inRevoke }
                    this.list = []
                    getSecretList(data).then(response => {
                        response.data.map(item => {
                            this.list.push({
                                alias: item.alias,
                                applicationId: item.applicationId,
                                description: item.description,
                                fullPath: item.fullPath,
                                group: item.group,
                                id: item.id,
                                isEnable: item.isEnable,
                                isSensitive: item.isSensitive,
                                isInRevoke: item.isInRevoke,
                                isFinishedRotate: item.isFinishedRotate,
                                keyType: item.keyType,
                                secretHashValue: item.secretHashValue,
                                shareType: item.shareType,
                                referenceSecretId: item.referenceSecretId,
                                referenceSecretName: item.referenceSecretName,
                                sharedApplicationIds: item.sharedApplicationIds,
                                versionInfos: item.versionInfos,
                                secret: '',
                                loading: false,
                                showHash: true
                            })
                        })
                        this.total = response.total
                        this.loading = false
                    }).catch(err => {
                        if (err.response.status === 404) {
                            localStorage.application = ''
                            this.filter.applicationId = ''
                        }
                        this.loading = false
                    })
                } else if (searchBy === 'refer') {
                    this.loading = true
                    const data = { prefixPath, applicationId, alias, pageSize, pageNo, referenceSecretId, strict, inRevoke }
                    this.list = []
                    getSecretList(data).then(response => {
                        response.data.map(item => {
                            this.list.push({
                                alias: item.alias,
                                applicationId: item.applicationId,
                                description: item.description,
                                fullPath: item.fullPath,
                                group: item.group,
                                id: item.id,
                                isEnable: item.isEnable,
                                isSensitive: item.isSensitive,
                                isInRevoke: item.isInRevoke,
                                isFinishedRotate: item.isFinishedRotate,
                                keyType: item.keyType,
                                secretHashValue: item.secretHashValue,
                                shareType: item.shareType,
                                referenceSecretId: item.referenceSecretId,
                                referenceSecretName: item.referenceSecretName,
                                sharedApplicationIds: item.sharedApplicationIds,
                                versionInfos: item.versionInfos,
                                secret: '',
                                loading: false,
                                showHash: true
                            })
                        })
                        this.total = response.total
                        this.loading = false
                    }).catch(err => {
                        if (err.response.status === 404) {
                            localStorage.application = ''
                            this.filter.applicationId = ''
                        }
                        this.loading = false
                    })
                } else {
                    this.$message.error('Some error has occurred, please try again')
                    this.filter.searchBy = ''
                }
            // } else {
            //     this.$message({
            //         type: 'warning',
            //         message: 'Please select an application'
            //     })
            // }
        },
        handleSelectionChange (val) {
            if (val.length) {
                if (val.length > 1) {
                    this.$refs.multipleTable.clearSelection()
                    this.$refs.multipleTable.toggleRowSelection(val[val.length - 1])
                }
                this.referenceSecretId = val[val.length - 1].id
            } else {
                this.referenceSecretId = ''
            }
        },
        submitReferenceSecret () {
            this.referenceVisible = false
            this.form.referenceSecretId = this.referenceSecretId
        },
        showReferenceList () {
            const applicationId = this.form.applicationId
            if (applicationId) {
            const { fullPath, alias, pageSize, pageNo } = this.referenceFilter
            const data = { fullPath, alias, pageSize, pageNo, applicationId }
            getShareKeyList(data).then(response => {
                this.referenceList = response.data
                this.referenceVisible = true
                this.referenceFilter.total = response.total
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
            } else {
                this.$message.warning('Please select an application')
            }
        },
        showCreate () {
            if (localStorage.namespace) {
                this.form.title = 'Create'
                this.form.id = ''
                this.form.namespace = localStorage.namespace
                this.form.applicationId = this.filter.applicationId
                this.form.prefixPath = JSON.parse(JSON.stringify(this.filter.prefixPath))
                this.pathList.form = JSON.parse(JSON.stringify(this.pathList.filter))
                if (this.form.prefixPath[this.form.prefixPath.length - 1] && this.form.prefixPath[this.form.prefixPath.length - 1].length) {
                    this.form.prefixPath.push('')
                }
                this.form.groupName = ''
                this.form.alias = ''
                this.form.description = ''
                this.form.keyType = 'COMMON'
                this.form.shareType = 'NORMAL'
                this.form.secret = ''
                this.form.referenceSecretId = ''
                this.form.sharedApplicationIds = []
                this.form.isSensitive = true
                this.form.isEnable = true
                this.form.visible = true
            } else {
                this.$message({
                    type: 'warning',
                    message: 'Please select a namespace before create secret!'
                })
            }
        },
        showSecret (id, showAll) {
            this.list.map(item => {
                if (item.id === id) {
                    console.log(item)
                    if ((item.showHash || showAll) && !item.secret) {
                        item.loading = true
                        getSecret(id).then(response => {
                            item.loading = false
                            item.secret = response.secret
                            item.showHash = false
                        }).catch(() => {
                            item.loading = false
                        })
                    } else if (showAll) {
                        item.showHash = false
                    } else {
                        item.showHash = !item.showHash
                    }
                }
            })
        },
        getAddVersionAction () {
            return process.env.VUE_APP_API_URL + 'backend/secret/addVersion'
        },
        batchAddVersion () {
            this.batchAddVersionForm.visible = true
            this.batchAddVersionForm.repeatAction = ''
            this.batchAddVersionForm.secret = ''
            this.batchAddVersionForm.secretType = 'file'
            this.$nextTick(() => {
                if (this.$refs.addVersionUpload) {
                    this.$refs.addVersionUpload.clearFiles()
                this.batchAddVersionForm.secretType = ''
                }
            })
        },
        addVersionUpload (content) {
            this.batchAddVersionForm.file = content.file
        },
        async doSend () {
            if (this.batchAddVersionForm.repeatAction === 'AddNewVersion') {
                this.batchAddVersionForm.visible = false
                this.batchAddResultForm.result = []
                await this.batchAdd()
            } else {
                this.$message.error('Wrong input, please check')
            }
        },
        async sendUpdateResult (row, isBatch) {
            const formData = new FormData()
            formData.append('id', row.id)
            if (this.batchAddVersionForm.secretType === 'file') {
                if (this.$refs.addVersionUpload.uploadFiles.length) {
                    // this.$refs.addVersionUpload.submit()
                    console.log(this.batchAddVersionForm.file)
                    formData.append('file', this.batchAddVersionForm.file)
                }
            } else {
                formData.append('secret', this.batchAddVersionForm.secret)
            }
            this.uploadingCount++
            addVersion(formData).then(response => {
                this.uploadingCount--
            }).catch(err => {
                this.batchAddResultForm.result.push({
                    path: row.fullPath,
                    msg: err.response.data.errorMessage
                })
                this.uploadingCount--
            })
        },
        async sendUpdateResults (i) {
            for (let j = 0; j < 10; j++) {
                if (i * 10 + j < this.selectLines.length) {
                    console.log(i, j)
                    this.sendUpdateResult(this.selectLines[i * 10 + j], true)
                }
            }
        },
        async batchAdd () {
            if (this.selectLines.length) {
                if (this.uploadingIndex < this.selectLines.length / 10) {
                    var that = this
                    new Promise(
                        function () {
                            that.sendUpdateResults(that.uploadingIndex)
                        }
                    ).then(res => {
                        this.uploadingIndex++
                        that.batchAdd()
                    })
                } else {
                    if (this.batchAddResultForm.result.length) {
                        this.batchAddResultForm.visible = true
                    } else {
                        this.$message.success('Batch add version success')
                        this.$refs.multipleTable.clearSelection()
                        this.fetchData()
                    }
                    this.uploadingCount = 0
                    this.uploadingIndex = 0
                }
            }
        },
        showSecrets () {
            if (this.showSecretsVisible) {
                this.list.map(item => {
                    item.showHash = true
                })
            } else {
                this.list.map(item => {
                    this.showSecret(item.id, true)
                })
            }
        },
        showRefer (id) {
            // this.$emit('searchBySecretName', secretName)
            this.tempFilter.applicationList = this.applicationList
            this.tempFilter.namespace = this.namespace
            this.tempFilter.applicationId = this.filter.applicationId
            this.tempFilter.prefixPath = this.filter.prefixPath
            this.tempFilter.alias = this.filter.alias
            this.tempFilter.secretHashValue = this.filter.secretHashValue
            this.tempFilter.strict = this.filter.strict
            this.namespace = ''
            this.filter.applicationId = ''
            this.filter.prefixPath = []
            this.filter.alias = ''
            this.filter.secretHashValue = ''
            this.filter.referenceSecretId = id
            this.filter.strict = false
            this.filter.searchBy = 'refer'
            this.filter.pageNo = 1
            this.fetchData()
        },
        showForceUpdate (row) {
            this.forceUpdateForm.id = row.id
            this.forceUpdateForm.secret = ''
            this.forceUpdateForm.alias = row.alias
            this.forceUpdateVisible = true
        },
        showSearchHash (id) {
            this.searchHashForm.title = 'Search Secret Value'
            this.searchHashForm.visible = true
            this.searchHashForm.secret = ''
        },
        showCheck (hashValue) {
            this.searchHashForm.title = 'Verify Secret Value'
            this.searchHashForm.secret = ''
            this.searchHashForm.hashValue = hashValue
            this.searchHashForm.visible = true
        },
        forceUpdateSecret () {
            if (this.forceUpdateForm.secretType === 'file') {
                if (this.$refs.updateUpload.uploadFiles.length) {
                    this.$refs.updateUpload.submit()
                } else {
                    this.$message.warning('Please select a file')
                }
            } else {
                const { id, secret } = this.forceUpdateForm
                const formData = new FormData()
                formData.append('secret', secret)
                formData.append('id', id)
                this.loading = true
                forceUpdateSecret(formData).then(response => {
                    this.$message.success('Update success')
                    this.loading = false
                    this.fetchData()
                    this.forceUpdateVisible = false
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        updateBatch () {
            if (this.$refs.batchUpload.uploadFiles.length) {
                this.$refs.batchUpload.submit()
            } else {
                this.$message.warning('Please select a file')
            }
        },
        hashSecret () {
            if (this.searchHashForm.secretType === 'file') {
                if (this.$refs.hashUpload.uploadFiles.length) {
                    this.$refs.hashUpload.submit()
                } else {
                    this.$message.warning('Please select a file')
                }
            } else {
                const { title, secret, hashValue } = this.searchHashForm
                const formData = new FormData()
                formData.append('secret', secret)
                this.loading = true
                hashSecret(formData).then(response => {
                    if (title === 'Search Secret Value') {
                        this.$message.success('Hash success')
                        this.filter.secretHashValue = response.secretHashValue
                        this.filter.searchBy = 'hash'
                        this.fetchData()
                        this.loading = false
                        this.searchHashForm.visible = false
                    } else {
                        this.loading = false
                        if (hashValue === response.secretHashValue) {
                            this.$message.success('Verify secret success')
                            this.searchHashForm.visible = false
                        } else {
                            this.$message.error('Verify secret failed')
                        }
                    }
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        showEdit (row) {
            this.form.title = 'Edit'
            this.form.id = row.id
            console.log(row.applicationId)
            this.form.applicationId = row.applicationId
            this.form.alias = row.alias
            this.form.fullPath = row.fullPath
            this.form.groupName = row.group
            console.log(row)
            this.form.isEnable = row.isEnable
            this.form.description = row.description
            this.form.keyType = row.keyType
            this.form.shareType = row.shareType
            this.form.oldType = row.shareType
            this.form.referenceSecretId = row.referenceSecretId
            this.form.isSensitive = row.isSensitive
            this.form.sharedApplicationIds = row.sharedApplicationIds
            this.form.secret = ''
            this.form.visible = true
        },
        showDuplicate () {
            if (!localStorage.namespace || !this.filter.applicationId) {
                this.$message.warning('Please select namespace and application before duplicate')
                return false
            }
            this.duplicateForm.namespace = localStorage.namespace
            this.duplicateForm.applicationId = this.filter.applicationId
            this.duplicateForm.prefixPath = JSON.parse(JSON.stringify(this.filter.prefixPath))
            this.pathList.duplicateForm = JSON.parse(JSON.stringify(this.pathList.filter))
            this.applicationList.map(item => {
                if (item.id === this.filter.applicationId) {
                    this.duplicateForm.applicationName = item.applicationName
                }
            })
            var prefixPath = ''
            for (var i = 0; i < this.filter.prefixPath.length; i++) {
                prefixPath += this.filter.prefixPath[i] ? '/' + this.filter.prefixPath[i] : ''
            }
            this.duplicateForm.sourcePath = this.duplicateForm.namespace + '/' + this.duplicateForm.applicationName + prefixPath
            if (this.duplicateForm.prefixPath[this.duplicateForm.prefixPath.length - 1] && this.duplicateForm.prefixPath[this.duplicateForm.prefixPath.length - 1].length) {
                this.duplicateForm.prefixPath.push('')
            }
            this.duplicateForm.visible = true
        },
        saveDuplicate () {
            const { namespace, applicationName, sourcePath, prefixPath, selectedSecrets } = this.duplicateForm
            var targetPath = namespace + '/' + applicationName
            var reg = /[A-Z]/
            prefixPath.map((path, i) => {
                if (path) {
                    if (reg.test(path)) {
                        this.$message({
                            type: 'warning',
                            message: 'Prefix path cannot contain uppercase letters:' + path
                        })
                        return false
                    }
                    targetPath += '/' + path
                }
            })
            var secretIds = []
            selectedSecrets.map(item => {
                secretIds.push(item.id)
            })
            this.loading = true
            const data = {
                secretIds,
                sourcePath,
                targetPath
            }
            duplicateSecret(data).then(response => {
                this.loading = false
                if (response.success) {
                    this.duplicateForm.visible = false
                    this.$message.success('Duplicate success')
                    if (response.result) {
                        this.duplicateResult.result = []
                        Object.keys(response.result).map(item => {
                            this.duplicateResult.result.push({
                                key: item,
                                value: response.result[item]
                            })
                        })
                        this.duplicateResult.visible = true
                    }
                    this.fetchData()
                    this.refreshPath()
                } else {
                    this.$message.error('Duplicate failed')
                }
            }).catch(() => {
                this.loading = false
            })
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.form.title === 'Create') {
                    // const { id, namespace, applicationId, groupName, alias, description, isdefault, isEmpty, keyType, secretType, shareType, isSensitive, isEnable } = this.form
                    const { id, namespace, applicationId, groupName, alias, description, isdefault, isEmpty, keyType, secretType, shareType, isSensitive, isEnable, sharedApplicationIds } = this.form
                    var prefixPath = []
                    var reg = /[A-Z]/
                    this.form.prefixPath.map(path => {
                        if (path) {
                            if (reg.test(path)) {
                                this.$message({
                                    type: 'warning',
                                    message: 'Prefix path cannot contain uppercase letters:' + path
                                })
                                return false
                            }
                            prefixPath.push(path)
                        }
                    })
                    const length = keyType === 'ENCRYPT' ? this.form.length : null
                    const secret = keyType === 'ENCRYPT' && !isdefault ? null : this.form.secret
                    const referenceSecretId = shareType === 'REFERENCE' ? this.form.referenceSecretId : null
                    if (secretType === 'file' && keyType === 'COMMON' &&
                        (!isEmpty && shareType !== 'REFERENCE')) {
                        if (this.$refs.upload.uploadFiles.length) {
                            const data = { namespace, applicationId, prefixPath, groupName, alias, description, keyType, shareType, isSensitive, isEnable }
                            this.uploadSecretData = data
                            this.$refs.upload.submit()
                        } else {
                            this.$message.warning('Please select a file')
                        }
                    } else {
                        // const data = { id, namespace, applicationId, prefixPath, groupName, alias, description, keyType, secret, referenceSecretId, length, isEmpty, shareType, isSensitive, isEnable }
                        const data = { id, namespace, applicationId, prefixPath, groupName, alias, description, keyType, secret, referenceSecretId, length, isEmpty, shareType, isSensitive, isEnable, sharedApplicationIds }
                        const formData = new FormData()
                        Object.keys(data).map(item => {
                            if (data[item] !== null) {
                                formData.append(item, data[item])
                            }
                        })
                        this.loading = true
                        createSecret(formData).then(response => {
                            this.loading = false
                            this.form.visible = false
                            this.$message.success('Create success')
                            // this.filter.prefixPath = this.form.prefixPath
                            this.fetchData()
                            this.refreshPath()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                } else {
                    // const { id, applicationId, groupName, description, isEmpty, secret, secretType, shareType, oldType, isEnable } = this.form
                    const { id, applicationId, groupName, description, isEmpty, secret, secretType, shareType, oldType, isEnable, sharedApplicationIds } = this.form
                    console.log(shareType, this.form.referenceSecretId)
                    const referenceSecretId = shareType === 'REFERENCE' ? this.form.referenceSecretId : null
                    if (secretType === 'file' && this.$refs.upload &&
                        (!isEmpty && shareType !== 'REFERENCE')) {
                        if (this.$refs.upload.uploadFiles.length) {
                            const data = { applicationId, secretId: id, groupName, description, shareType, isEnable }
                            this.uploadSecretData = data
                            this.$refs.upload.submit()
                        } else {
                            this.$message.warning('Please select a file')
                        }
                    } else {
                        // const data = { applicationId, secretId: id, groupName, description, secret, referenceSecretId, isEmpty, shareType, isEnable }
                        const data = { applicationId, secretId: id, groupName, description, secret, referenceSecretId, isEmpty, shareType, isEnable, sharedApplicationIds }
                        const formData = new FormData()
                        Object.keys(data).map(item => {
                            if (data[item] !== null) {
                                formData.append(item, data[item])
                            }
                        })
                        if (oldType !== 'REFERENCE' && shareType === 'REFERENCE') {
                            this.$confirm('This will delete the old secret. Continue?', 'Warning', {
                                confirmButtonText: 'Continue',
                                cancelButtonText: 'Cancel',
                                type: 'warning'
                            }).then(() => {
                                this.loading = true
                                createSecret(formData).then(response => {
                                    this.loading = false
                                    this.form.visible = false
                                    this.$message.success('Update success')
                                    this.fetchData()
                                }).catch(() => {
                                    this.loading = false
                                })
                            }).catch(() => {
                                this.loading = false
                                this.$message({
                                    type: 'info',
                                    message: 'Update canceled'
                                })
                            })
                        } else {
                            this.loading = true
                            createSecret(formData).then(response => {
                                this.loading = false
                                this.form.visible = false
                                this.$message.success('Update success')
                                this.fetchData()
                            }).catch(() => {
                                this.loading = false
                            })
                        }
                    }
                }
                } else {
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        refreshPath () {
            if (this.filter.applicationId) {
                const pathData = {
                    namespace: this.namespace,
                    applicationId: this.filter.applicationId,
                    parentFullPath: ''
                }
                listPath(pathData).then(response => {
                    this.pathList.filter[0] = response.data
                })
                this.filter.prefixPath.map((item, index) => {
                    if (item) {
                        this.fetchPath(index + 1, this.filter.prefixPath, this.filter.applicationId, 'filter')
                    }
                })
            }
        },
        secretUpload (content) {
            const formData = new FormData()
            console.log(content)
            console.log(content.file.size)
            if (content.file.size > 65535) {
                this.$message.warning('File is limited in 65535b!')
                return false
            }
            // const { title, id, namespace, applicationId, groupName, alias, description, keyType, shareType, isSensitive, isEnable } = content.data
            const { title, id, namespace, applicationId, groupName, alias, description, keyType, shareType, isSensitive, isEnable, sharedApplicationIds } = content.data
            var prefixPath = []
            var reg = /[A-Z]/
            content.data.prefixPath.map(path => {
                if (path) {
                    if (reg.test(path)) {
                        this.$message({
                            type: 'warning',
                            message: 'Prefix path cannot contain uppercase letters:' + path
                        })
                        return false
                    }
                    prefixPath.push(path)
                }
            })
            var data = {}
            if (title === 'Edit') {
                // data = { applicationId, secretId: id, groupName, description, shareType, isEnable }
                data = { applicationId, secretId: id, groupName, description, shareType, isEnable, sharedApplicationIds }
            } else {
                // data = { namespace, applicationId, prefixPath, groupName, alias, description, keyType, shareType, isSensitive, isEnable }
                data = { namespace, applicationId, prefixPath, groupName, alias, description, keyType, shareType, isSensitive, isEnable, sharedApplicationIds }
            }
            formData.append('file', content.file)
            Object.keys(data).map(item => {
                if (data[item] !== null) {
                    formData.append(item, data[item])
                }
            })
            this.loading = true
            axios({
                method: 'post',
                url: content.action,
                headers: content.headers,
                data: formData
            }).then(res => {
                this.loading = false
                content.onSuccess(res)
            }).catch(err => {
                this.loading = false
                content.onError(err)
            })
        },
        updateUpload (content) {
            const formData = new FormData()
            if (content.file.size > 65535) {
                this.$message.warning('File is limited in 65535b!')
                return false
            }
            formData.append('file', content.file)
            formData.append('id', content.data.id)
            this.loading = true
            axios({
                method: 'put',
                url: content.action,
                headers: content.headers,
                data: formData
            }).then(res => {
                this.loading = false
                content.onSuccess(res)
            }).catch(err => {
                this.loading = false
                content.onError(err)
            })
        },
        downloadUpdateTemplate (command) {
            downloadUpdateTemplate(command).then(response => {
                var fileName = ''
                try {
                    fileName = response.headers['content-disposition'].split('filename=')[1]
                } catch {
                    fileName = 'template.csv'
                }
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.download = fileName
                document.body.appendChild(link)
                link.click()
            })
        },
        downloadTemplate (command) {
            if (command === 'upload') {
                var btn = document.getElementById('secret-upload')
                btn.click()
                // this.show
            } else {
                downloadTemplate(command).then(response => {
                    var fileName = 'template.' + command
                    const url = window.URL.createObjectURL(new Blob([response]))
                    const link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.download = fileName
                    document.body.appendChild(link)
                    link.click()
                })
            }
        },
        downloadMetadata () {
            if (this.filter.applicationId) {
                var applicationName = ''
                this.applicationList.map(item => {
                    if (item.id === this.filter.applicationId) {
                        applicationName = item.applicationName
                    }
                })
                var prefixPath = applicationName ? this.namespace + '/' + applicationName : this.namespace
                for (var i = 0; i < this.filter.prefixPath.length; i++) {
                    prefixPath += this.filter.prefixPath[i] ? '/' + this.filter.prefixPath[i] : ''
                }
                this.downloadMetadataLoading = true
                downloadMetadata(prefixPath).then(response => {
                    this.downloadMetadataLoading = false
                    console.log(response.headers['content-disposition'].split('filename=')[1])
                    var fileName = ''
                    try {
                        fileName = response.headers['content-disposition'].split('filename=')[1]
                    } catch {
                        fileName = 'file.csv'
                    }
                    console.log(response.data)
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.download = fileName
                    document.body.appendChild(link)
                    link.click()
                }).catch(() => {
                    this.downloadMetadataLoading = false
                })
            } else {
                this.$message.warning('Please select an application')
            }
        },
        handleSelect (val) {
            this.deleteIds = []
            this.selectLines = []
            this.duplicateForm.selectedSecrets = JSON.parse(JSON.stringify(val))
            val.map(item => {
                this.deleteIds.push(item.id)
                this.selectLines.push(item)
            })
        },
        deleteSecret (id) {
            this.$confirm('This will delete the secret. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteSecret(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    if (response.failedList.length) {
                        this.failedList = response.failedList
                        this.failedVisible = true
                    }
                    this.$message({
                        type: response.failedNum ? 'warning' : 'success',
                        message: 'Success:' + response.successNum + ', Failed:' + response.failedNum
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        handleSizeChange (val) {
            this.filter.pageSize = val
            this.fetchData()
        },
        handleReferenceSizeChange (val) {
            this.referenceFilter.pageSize = val
            this.showReferenceList()
        },
        backToSearch () {
            this.filter.searchBy = ''
            this.namespace = this.tempFilter.namespace
            this.$nextTick(() => {
                this.applicationList = this.tempFilter.applicationList
                this.filter.applicationId = this.tempFilter.applicationId
                this.filter.prefixPath = this.tempFilter.prefixPath
                this.filter.alias = this.tempFilter.alias
                this.filter.secretHashValue = this.tempFilter.secretHashValue
                this.filter.strict = this.tempFilter.strict
                this.fetchData()
            })
        },
        handleClose (tag) {
            this.duplicateForm.selectedSecrets.splice(this.duplicateForm.selectedSecrets.indexOf(tag), 1)
        },
        filterRevoke (command) {
            this.filter.inRevoke = command
            this.fetchData()
        },
        hideVersionList () {
            this.versionListVisible = false
            this.fetchData()
        },
        handleCommand (command) {
            if (command.command === 'showForceUpdate') {
                this.showForceUpdate(command.param)
            } else if (command.command === 'showEdit') {
                this.showEdit(command.param)
            }
        },
        handleMoreCommand (command) {
            if (command.command === 'showCheck') {
                this.showCheck(command.param)
            } else if (command.command === 'showRefer') {
                this.showRefer(command.param)
            }
        }
    }
}
</script>
<style>
.strictmode-popper.zm-tooltip__popper {
    word-break: break-word;
}
#secretDialogTable.zm-table thead th .zm-checkbox {
    display: none;
}
.upload-demo {
    display: inline-block;
}
.upload-demo .zm-upload {
    float: left;
    margin-bottom: -11px;
    margin-left: 8px;
    /* margin-right: 8px; */
}
.create-dropdown {
    margin: 10px 0 0 10px;
}
.input-tag {
    margin: 4px 10px 4px 0;
    padding: 0 20px 0 10px;
    height: 32px;
    line-height: 28px;
}
.input-tag.zm-tag .zm-tag__close {
    top: 7px;
}
</style>
